import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { LAX } from 'constants/Markets';
import { Map } from 'components/maps';
import DriverMarker from 'components/modules/shipper/DriverMarker';
import JobDetails from 'components/modules/shipments/tracking/JobDetails';
import SessionStore from 'stores/SessionStore';
import ShipmentWebAPIUtils from 'utils/ShipmentWebAPIUtils';

const DEFAULT_ZOOM = 10;

export default class DriverTrackingMap extends Component {
  static propTypes = {
    center: PropTypes.arrayOf(PropTypes.number).isRequired,
    className: PropTypes.object,
    markers: PropTypes.array,
    selectedShipment: PropTypes.object,
    onOpenShipment: PropTypes.func.isRequired,
    onMapClick: PropTypes.func.isRequired,
    onMarkerClick: PropTypes.func.isRequired,
    onCloseInfoWindow: PropTypes.func.isRequired,
    drivers: PropTypes.arrayOf(
      PropTypes.shape({
        _id: PropTypes.string.isRequired,
        first_name: PropTypes.string.isRequired,
        last_name: PropTypes.string.isRequired,
      }),
    ),
    activeDriver: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      fullName: PropTypes.string.isRequired,
      equipmentClassLabel: PropTypes.string.isRequired,
    }),
    setCurrentMarker: PropTypes.func,
  };

  static defaultProps = {
    className: {},
    selectedShipment: null,
    drivers: [],
    activeDriver: null,
    markers: [],
  };

  constructor(props) {
    super(props);
    this.setDefaultCenter();
    this.state = { openMarkerId: null };
  }

  getDriverJobs = async (shipments) => {
    try {
      const jobs = await ShipmentWebAPIUtils.getDriverJobs(shipments);
      return jobs;
    } catch (e) {
      console.log('ERROR: ', e);
    }
  };

  setDefaultCenter() {
    const { origin } = SessionStore.getUser();
    this.defaultCenter = origin ? origin.coords.slice().reverse() : LAX.center;
  }

  handleMapClick = () => this.props.onMapClick();

  handleMarkerClick = (id) => {
    this.setState({ openMarkerId: id });
    this.props.onMarkerClick(id);
    if (this.props.setCurrentMarker) {
      this.props.setCurrentMarker(id);
    }
  };

  handleCloseInfoWindow = (id) => {
    this.setState({ openMarkerId: null });
    this.props.onCloseInfoWindow(id);
  };

  renderMarkers() {
    return this.props.markers.map((marker) => (
      <DriverMarker
        key={marker.id}
        id={marker.id}
        position={marker.position}
        isOpen={this.state.openMarkerId === marker.id}
        driver={marker.driver}
        phone={marker.phone}
        jobs={marker.jobs || []}
        hasActiveJobs={marker.hasActiveJobs}
        onOpenShipment={this.props.onOpenShipment}
        onCloseInfoWindow={this.handleCloseInfoWindow}
        onMarkerClick={this.handleMarkerClick}
      />
    ));
  }

  renderJobDetails() {
    if (!this.props.selectedShipment) return null;
    return (
      <JobDetails
        job={this.props.selectedShipment}
        drivers={this.props.drivers}
        activeDriver={this.props.activeDriver}
      />
    );
  }

  render() {
    const className = classnames({
      ...this.props.className,
      'shipments-tracking': true,
    });

    const center = this.props.center || [...this.defaultCenter];
    const fitBoundsTo = this.props.markers.map((m) => m.position);

    return (
      <div className={className}>
        <Map
          height="100%"
          defaultZoom={DEFAULT_ZOOM}
          defaultCenter={{ lat: center[0], lng: center[1] }}
          fitBoundsTo={fitBoundsTo.length > 0 ? fitBoundsTo : undefined}
          onClick={this.handleMapClick}
          options={{
            zoomControlOptions: {
              position: google.maps.ControlPosition.RIGHT_BOTTOM,
            },
            streetViewControlOptions: {
              position: google.maps.ControlPosition.RIGHT_BOTTOM,
            },
            streetViewControl: true,
            mapTypeControl: false,
          }}
        >
          {this.renderMarkers()}
        </Map>
        {this.renderJobDetails()}
      </div>
    );
  }
}
